import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="other-reason-form"
export default class extends Controller {
  static targets = ["otherReason", "otherReasonField", "selectReason"]

  static classes = ["hidden"]

  checkOtherSelected() {
    const selectedOptionText = this.selectReasonTarget.options[this.selectReasonTarget.selectedIndex].text;

    if (selectedOptionText === "Other") {
      this.otherReasonTarget.classList.remove(this.hiddenClass)
      this.otherReasonFieldTarget.focus()
    }
    else {
      this.otherReasonTarget.classList.add(this.hiddenClass)
    }
  }
}
